import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedShiftRoleSelector($companyId: ID!, $id: ID) {
    shiftRoles(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
      }
    }
  }
`

export const Query = gql`
  query ShiftRoleSelector(
    $companyId: ID!,
    $filters: ShiftRoleFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    shiftRoles(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
